import { SearchOutlined } from '@ant-design/icons';
import {
  Breadcrumb,
  Button,
  Col,
  Input,
  Pagination,
  Popconfirm,
  Row,
  Space,
  Table,
  Tooltip,
  message
} from 'antd';
import dayjs from 'dayjs';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { ReactComponent as ArchiveRestore } from "../../Images/ArchiveRestore.svg";
import { ReactComponent as Back } from '../../Images/Back.svg';
import { ReactComponent as FilterIcon } from '../../Images/FilterIcon.svg';
import { fetchArchivedDieCategoryList, unArchiveDieCategory } from './../../slices/die-category';

export default function ArchiveDieCategories() {
  const dispatch = useDispatch();
  const [page, setPage] = useState(1);
  const [orderBy, setOrderBy] = useState('');
  const [pagesize, setPageSize] = useState(10);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const { data = [], totalRecord, status } = useSelector(state => state.dieCategory || {});
  const [inputValue, setInputValue] = useState(localStorage.getItem('ArchiveDieCategories') || '');
  const [search, setSearch] = useState(localStorage.getItem('ArchiveDieCategories') || '');

  useEffect(() => {
    dispatch(
      fetchArchivedDieCategoryList({ page, pagesize, ...(search && { search: search }), ...(orderBy && { ordering: orderBy }) }),
    );
  }, [dispatch, page, pagesize, search, orderBy]);

  const rowSelection = {
    selectedRowKeys,
    onChange: (selectedKeys) => {
      setSelectedRowKeys(selectedKeys);
    },
  };

  const handleSearch = (e) => {
    const value = e.target.value;
    setInputValue(value);
    setSearch(value);
    localStorage.setItem('ArchiveDieCategories', value);
  };

  const resetFilter = () => {
    setSearch('');
    setInputValue('');
    setOrderBy(null); // if applicable
    localStorage.removeItem('ArchiveDieCategories');
    dispatch(fetchArchivedDieCategoryList({ page: 1, pagesize }));
  };

  const handlePageChange = newPage => {
    setPage(newPage);
  };
  const GetSortingEnumValue = (sortField, sortOrder) => {
    let sortingEnumKey = "id";

    if (sortField === "name" && sortOrder === "ascend") {
      sortingEnumKey = "name";
    }
    if (sortField === "name" && sortOrder === "descend") {
      sortingEnumKey = "-name";
    }
    if (sortField === "updated_at" && sortOrder === "ascend") {
      sortingEnumKey = "updated_at";
    }
    if (sortField === "-updated_at" && sortOrder === "descend") {
      sortingEnumKey = "-updated_at";
    }
    if (sortField === "updated_by" && sortOrder === "ascend") {
      sortingEnumKey = "updated_by";
    }
    if (sortField === "-updated_by" && sortOrder === "descend") {
      sortingEnumKey = "-updated_by";
    }
    return sortingEnumKey;
  };

  const handleTableChange = async (pagination, filters, sorter, ordering) => {
    if (sorter && sorter.columnKey && sorter.order) {
      const orderBy = GetSortingEnumValue(sorter.columnKey, sorter.order);
      setOrderBy(orderBy);
    }
    setPageSize(pagination.pageSize);
  };
  const dataSource = data.map((item, index) => ({
    ...item,
    key: item.id || index,
    SrNo: (page - 1) * pagesize + index + 1, // Calculate Sr. No. based on page and limit
  }));

  const handleRestore = (id) => {
    if (!id) {
      message.error('Missing ID for deletion!');
      return;
    }
    dispatch(unArchiveDieCategory(id))
      .unwrap()
      .then(() => {
        message.success('Section Category Unarchived successfully!');
        dispatch(
          fetchArchivedDieCategoryList({ page, pagesize, ...(search && { search: search }) }),
        );
      })
      .catch((err) => {
        console.error('Delete Error:', err); // Debugging the error
        message.error(`Error: ${err.message || 'Failed to delete the group.'}`);
      });
  };

  const columns = [
    {
      title: 'Sr. No.',
      dataIndex: 'SrNo',
      key: 'SrNo',
      width: 100,
    },
    {
      title: 'Category Name',
      dataIndex: 'name',
      key: 'name',
      width: 300,
      sorter: true,
    },
    {
      title: 'Archive At',
      dataIndex: 'updated_at',
      key: 'updated_at',
      width: 100,
      sorter: true,
      render: (record) => {
        return (
          <span>{record ? dayjs(record).format('DD-MM-YYYY HH:mm') : 'N/A'} </span>
        )
      }
    },
    {
      title: 'Archive By',
      dataIndex: 'updated_by',
      key: 'updated_by',
      width: 100,
      sorter: true,
      render: ((record) => {
        return (
          <span>{record ? `${record.first_name} ${record.last_name}` : 'N/A'} </span>
        )
      })
    },
    {
      title: 'Action',
      dataIndex: '',
      key: 'action',
      fixed: 'right',
      width: 100,
      render: (text, record) => (
        <Space>
          <Link>
            <Tooltip title="Restore">
              <Popconfirm
                title="Are you sure you want to Unarchive this record?"
                onConfirm={() => handleRestore(record.id)} // Trigger delete on confirmation
                onCancel={() => message.info('Action cancelled')} // Optional cancel action
                okText="Yes"
                cancelText="No"
              >
                <ArchiveRestore className="ArchiverestorImg" />
              </Popconfirm>
            </Tooltip>
          </Link>
        </Space>
      ),
    },
  ];

  const handlePageSizeChange = (current, size) => {
    setPage(1); // Reset to first page if needed
    setPageSize(size); // You must have a setter or state update
  };

  return (
    <>
      <div className='sticyaction'>
        <Row className="pagenamerow" justify="space-between" align="middle">
          <Col>
            <h2 style={{ margin: 0 }}>Archived Section Categories</h2>
            <div className="bredcrumbwrp">
              <Link to="/die-category" className="back">
                <Back /> BACK
              </Link>
              <Breadcrumb
                items={[
                  { title: <Link to="/die-category">Section Categories</Link> },
                  { title: 'Archived Section Categories' }
                ]}
              />
            </div>
          </Col>
          <Col>
            <Space>
              <Input
                placeholder="Search"
                className='searchbox'
                prefix={<SearchOutlined />}
                value={search}
                style={{ width: 200 }}
                onChange={handleSearch}
              />
              <Link>
                <Tooltip placement="top" title={'Reset Filter'}>
                  <Button type="primary" disabled={!search} className='iconlink' onClick={resetFilter}>
                    <FilterIcon />
                  </Button>
                </Tooltip>
              </Link>
            </Space>
          </Col>
        </Row>
      </div>
<div style={{ height: '100vh', display: 'flex', flexDirection: 'column' }}>
        <div style={{ flex: 1, overflow: 'auto' }}>
          <Table
            rowKey="id"
            //rowSelection={rowSelection}
            dataSource={dataSource}
            columns={columns}
            pagination={false}
            loading={status === 'loading'}
            onChange={handleTableChange}
          />
        </div>
        <div
          style={{
            position: 'sticky',
            bottom: 0,
            zIndex: 1000,
            background: '#fff',
            padding: 10,
            display: 'flex',
            justifyContent: 'flex-end',
          }}
        >
          <Pagination
            current={page}
            pageSize={pagesize}
            total={totalRecord}
            showSizeChanger
            onShowSizeChange={handlePageSizeChange}
            showTotal={total => `Total ${total} items`}
            onChange={handlePageChange}
            locale={{ items_per_page: 'Items / Page' }}
          />
        </div>
      </div>
    </>
  );
}
